export default __webpack_public_path__ + "static/media/extra gb.0cb2545a.png";